import baseAPI from '../axiosApi'

const api={
    list:'/api-ir/international/agreement/page',
    add:'/api-ir/international/agreement/add',
    update:'/api-ir/international/agreement/edit',
    info:'/api-ir/international/agreement/info/',
    del:'/api-ir/international/agreement/delete/',
}
// 查询协议管理列表
export function list (data) {
    return baseAPI.axiosData(api.list,'get',data)
}
// 新增协议管理
export function add (data) {
    return baseAPI.axiosData(api.add,'post',data)
}
// 修改协议管理
export function update (data) {
    return baseAPI.axiosData(api.update,'put',data)
}
// 查询协议管理信息
export function info (id) {
    return baseAPI.axiosData(api.info+id,'get')
}
// 删除协议管理
export function del (id) {
    return baseAPI.axiosData(api.del+id,'delete')
}
